/* eslint-disable no-param-reassign */
import * as React from 'react';
import { setConfig } from '@leagueplatform/core';
import { queryHelpers, useMediaQuery } from '@leagueplatform/genesis-core';

export function useDynamicConfig() {
  const isLaptopUp = useMediaQuery(queryHelpers.up('laptop'));

  React.useEffect(() => {
    setConfig((config) => {
      config.careDiscovery = {
        ...config.careDiscovery,
        ...{
          masonryAppId: !isLaptopUp
            ? {
                left: 'cigna_care_homepage',
              }
            : {
                left: 'cigna_care_homepage_left',
                right: 'cigna_care_homepage_right',
              },
        },
      };

      return config;
    });
  }, [isLaptopUp]);
}
